import React from 'react';

type BuffetType = 'breakfast' | 'lunch' | 'dinner';

interface BuffetTypeSelectorProps {
  onSelect: (type: BuffetType) => void;
  onCancel: () => void;
  prices?: {
    breakfast: number;
    lunch: number;
    dinner: number;
  };
}

const BuffetTypeSelector: React.FC<BuffetTypeSelectorProps> = ({ onSelect, onCancel, prices }) => {
  const buffetTypes: { type: BuffetType; label: string; emoji: string }[] = [
    { type: 'breakfast', label: 'Breakfast', emoji: '🌅' },
    { type: 'lunch', label: 'Lunch', emoji: '☀️' },
    { type: 'dinner', label: 'Dinner', emoji: '🌙' },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto my-auto">
        <div className="p-4 border-b flex justify-between items-center">
          <h2 className="text-xl font-bold text-gray-800">Select Buffet Type</h2>
          <button 
            onClick={onCancel} 
            className="text-gray-500 hover:text-gray-800 text-2xl"
          >
            ×
          </button>
        </div>
        
        <div className="p-6">
          <p className="text-sm text-gray-600 mb-4 text-center">
            Buffet orders require upfront payment and include a 1-hour time allocation.
          </p>
          
          <div className="space-y-3">
            {buffetTypes.map(({ type, label, emoji }) => {
              const price = prices?.[type] || 0;
              return (
                <button
                  key={type}
                  onClick={() => onSelect(type)}
                  className="w-full p-4 border-2 border-gray-200 rounded-lg hover:border-pink-400 hover:bg-pink-50 transition-colors text-left"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <span className="text-3xl">{emoji}</span>
                      <div>
                        <div className="font-semibold text-gray-800">{label}</div>
                        {price > 0 ? (
                          <div className="text-sm text-gray-600">${price.toFixed(2)}</div>
                        ) : (
                          <div className="text-xs text-yellow-600">Price not configured</div>
                        )}
                      </div>
                    </div>
                    <div className="text-pink-600 font-semibold">→</div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
        
        <div className="p-4 border-t bg-gray-50 flex justify-end">
          <button
            onClick={onCancel}
            className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-semibold"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default BuffetTypeSelector;

